function camelCaseToSnakeCase(string) {
  return string
    .replace(/(.)([A-Z][a-z]+)/g, '$1_$2') // insert underscores before words
    .replace(/([a-z0-9])([A-Z]+)/g, '$1_$2') // insert underscores before abbreviations
    .toLowerCase();
}

export function camelCaseObjectToSnakeCase(obj) {
  return Object.keys(obj)
    .map((key) => {
      const value = obj[key];

      return { [camelCaseToSnakeCase(key)]: value };
    })
    .reduce((accumulator, currentValue) => Object.assign(accumulator, currentValue), {});
}
